import React from 'react';
import TagSymphony from './TagSymphony';
import { CAMPAIGN_STATUS_INFO, CampaignStatus } from 'modules/Const';

interface CampaignStatusTagProps {
    status: string;
    className?: string;
}

const CampaignStatusTag: React.FC<CampaignStatusTagProps> = ({ 
    status, 
    className = 'campaignStatusTag'
}) => {
    const statusInfo = CAMPAIGN_STATUS_INFO[status as CampaignStatus];
    const title = statusInfo?.title || status.toUpperCase();
    const color = statusInfo?.color || 'grey';

    return (
        <TagSymphony
            className={className}
            title={title}
            color={color as any}
            type="square"
        />
    );
};

export default CampaignStatusTag; 